
import useApi from '../../hook/useAPI';
import {ZONE_TIMER} from '../../utils/const';



export const useTimerHandlers = () => {
  const {postData,getData} = useApi();

  const getTimerData = async (zone_id) => {
    const timer = await getData(`${ZONE_TIMER.GET_TRIP}/${zone_id}`);
    return timer;
  }
  const startTimer = async (start_time,zone_id) => {
     const timer = await postData(`${ZONE_TIMER.CREATE_TRIP}`,{
            start_time:start_time,
            zone_id:zone_id
          });
        
      return timer;
  };

  const stopTimer = async (end_time,timer_id) => {
    await postData(`${ZONE_TIMER.END_TRIP}/${timer_id}`,{
           end_time
          });
  };

  const resumeTimer = async (resume_time,new_start_time,timer_id) => {
    await postData(`${ZONE_TIMER.RESUME_TRIP}/${timer_id}`,{
             resume_time,
             adjust_start_time:new_start_time
          });
  };

  const pauseTimer = async (pause_time,timer_id) => {
    await postData(`${ZONE_TIMER.PAUSE_TRIP}/${timer_id}`,{
              pause_time
          });
  };

  return {
    startTimer,
    stopTimer,
    resumeTimer,
    pauseTimer,
    getTimerData
  };
};
